import Dialog from "dialog";
import template from "../html/dialog-new.html";
import css from "../css/dialog-new.css";
import moment from "moment";

import {DateTimePicker} from "picker";
//import {ColorPicker} from "picker";
import Datatable from "datatable";
import {Textbox} from "gui";
import ColorPicker from "../controls/textbox-colorpicker.js";


/*
	this dialog simply generates form data from its content
    and loads it back

    form data parameters also conrol the process of fermentation
    for example if form.running = true then the fermentation will start

    generated tabular data look like this: (https://www.w3.org/TR/csv2json/)
    [{ 
      "countryCode": "AD", 
      "latitude": "42.5", 
      "longitude": "1.6", 
      "name": "Andorra" 
    }, { 
      "countryCode": "AE", 
      "latitude": "23.4", 
      "longitude": "53.8", 
      "name": "United Arab Emirates" 
    }, { 
      "countryCode": "AF", 
      "latitude": "33.9", 
      "longitude": "67.7", 
      "name": "Afghanistan" 
    }]
*/


class NewDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-newdialog", NewDialog);
  }
  constructor(id) {
    super(id);       

    if (id) {
      server.rcall("RM_fermentation_load", id).then(function(result) {
        this.show();
                
        this._textboxID.value = id;
        if (result.operator) this.textboxOperator.value = result.operator;
        if (result.created)  this.textboxCreated.value = result.created;

        this._spinnerTargetTemperature.value = result.targetTemperature;
        this._spinnerTargetPH.value = result.targetPH;
        this.spinnerPHDeadband.value = result.pHDeadband;
        this._spinnerFeedRate.value = result.feedRate;
        this._spinnerOxygenLevel.value = result.oxygenLevel;
        this._spinnerAirFlow.value = result.airFlow;
        this.dateTimeSunrise.value = result.sunrise;        
        this.dateTimeSunset.value = result.sunset;
        this.textboxRGB.value = result.rgb ? result.rgb : "";
        this.datetimepickerEndDate.value = result.endDate;
        this.datetimepickerEndDate_change();
        this.datetimepickerInoculationDate.value = result.inoculationDate;
        this._checkboxRunning.checked = result.running;

        if (result.strainName) this.textboxStrainName.value = result.strainName;
        if (result.medium) this.textboxMedium.value = result.medium;
        if (result.carbonSource) this.textboxCarbonSource.value = result.carbonSource;
        if (result.unit) this.textboxUnit.value = result.unit;
        if (result.acceptor) this.textboxAcceptor.value = result.acceptor;
        if (result.chromosome) this.textboxChromosome.value = result.chromosome;
        if (result.plasmids) this.textboxPlasmids.value = result.plasmids;
        if (result.dilution) this.textboxDilution.value = result.dilution;
        if (result.process) this.textboxProcess.value = result.process;
        if (result.od600) this.textboxOD600.value = result.od600;
        if (result.startingVolume) this.textboxStartingVolume.value = result.startingVolume;
        if (result.density)	this.textboxDensity.value = result.density;

        if (result.aim)	this.textareaAim.value = result.aim;

        if (result.cellBank) this.textboxCellBank.value = result.cellBank;
        if (result.streakDate) this.textboxStreakDate.value = result.streakDate;
        if (result.antibiotics)	this.textboxAntibiotics.value = result.antibiotics;
        if (result.plateMedium)	this.textboxPlateMedium.value = result.plateMedium;

        if(result.inoculums) {
          for (const row of result.inoculums) {
            this.datatableInoculums.appendChild( new Datatable.Row() );
            for (const key in row) {
              this.datatableInoculums.lastElementChild.appendChild( new Textbox({value: row[key]}) );
            }
          }
        }

        if(result.growthData) {
          for (const row of result.growthData) {
            this.datatableGrowthData.appendChild( new Datatable.Row() );
            for (const key in row) {
              this.datatableGrowthData.lastElementChild.appendChild( new Textbox({value: row[key]}) );
            }
          }
        }

        if(result.analyticalData) {
          /* flush rows, built table  */
          this.datatableAnalyticalData.innerHTML = "";

          /* build header */
          var header = this.datatableAnalyticalData.appendChild( new Datatable.Row() );
          for (const key in result.analyticalData[0]) {
            header.appendChild( new Textbox({value: key}) );
          }

          /* build content */
          for (const row of result.analyticalData) {
            this.datatableAnalyticalData.appendChild( new Datatable.Row() );
            for (const key in row) {
              this.datatableAnalyticalData.lastElementChild.appendChild( new Textbox({value: row[key]}) );
            }
          }
        }

      }.bind(this)).catch(function(result) {
        alert(result);
      }.bind(this));
    }

    this.show();
  }
  /*
  connectedCallback() {
    super.connectedCallback();

    this.datetimepickerEndDate_change();
  }
  */
  divisionLogic_mouseover(isHover) {
    this.division_rick.style.backgroundImage = "url('../imgs/Rick_Sanchez_Render.png')";
    this.divisionLogic.style.backgroundImage = "url('../imgs/portal.gif')";
    this.divisionLogic.style.border = "none";
  }
  divisionLogic_mouseleave(isHover) {
    this.division_rick.style.backgroundImage = "url('../imgs/Rick_Sanchez.png')";
    this.divisionLogic.style.backgroundImage = "url('../imgs/logic.png')";
  }
  buttonSave_click(event) {

    var inoculums=[];
    for (let rows=this.datatableInoculums.children, header=rows[0].children, n=rows.length, i=1; i<n; i++) {
      let row = {};
      for(var cells=rows[i].children, m=cells.length, j=0; j<m; j++) {
        row[header[j].value]=cells[j].value;
      }
      inoculums.push(row);
    }

    var growthData=[];
    for (let rows=this.datatableGrowthData.children, header=rows[0].children, n=rows.length, i=1; i<n; i++) {
      let row = {};
      for(let cells=rows[i].children, m=cells.length, j=0; j<m; j++) {
        row[header[j].value]=cells[j].value;
      }
      growthData.push(row);
    }

    var analyticalData=[];
    for (let rows=this.datatableAnalyticalData.children, header=rows[0].children, n=rows.length, i=1; i<n; i++) {
      let row = {};
      for(let cells=rows[i].children, m=cells.length, j=0; j<m; j++) {
        row[header[j].value]=cells[j].value;
      }
      analyticalData.push(row);
    }    
    
    console.log(this.datetimepickerInoculationDate.value);
    console.log(this.datetimepickerInoculationDate.value===null);

    var form = {
      id:					this._textboxID.value,
      operator:				this.textboxOperator.value,
      created:				this.textboxCreated.value,

      targetTemperature:	this._spinnerTargetTemperature.value,
      targetPH:				this._spinnerTargetPH.value,
      pHDeadband:			this.spinnerPHDeadband.value,
      feedRate:				this._spinnerFeedRate.value,
      oxygenLevel:			this._spinnerOxygenLevel.value,
      sunrise:				this.dateTimeSunrise.value,
      sunset:				this.dateTimeSunset.value,
      rgb:					this.textboxRGB.value,
      airFlow:				this._spinnerAirFlow.value,
      endDate:				this.datetimepickerEndDate.value,
      inoculationDate:		this.datetimepickerInoculationDate.value,
      running:				this._checkboxRunning.checked,

      strainName:			this.textboxStrainName.value,
      medium:				this.textboxMedium.value,
      carbonSource:			this.textboxCarbonSource.value,
      unit:					this.textboxUnit.value,
      acceptor:				this.textboxAcceptor.value,
      chromosome:			this.textboxChromosome.value,
      plasmids:				this.textboxPlasmids.value,
      dilution:				this.textboxDilution.value,
      process:				this.textboxProcess.value,
      od600:				this.textboxOD600.value,
      startingVolume:		this.textboxStartingVolume.value,
      density:				this.textboxDensity.value,

      aim:					this.textareaAim.value,

      cellBank:				this.textboxCellBank.value,
      streakDate:			this.textboxStreakDate.value,
      antibiotics:			this.textboxAntibiotics.value,
      plateMedium:			this.textboxPlateMedium.value,

      inoculums:			inoculums,
      growthData:			growthData,
      analyticalData:		analyticalData
    };

    server.rcall("RM_fermentation_save", form).then(function(result) {
      this.close();
    }.bind(this)).catch(function(result) {
      error(result);
    }.bind(this));
  }
  buttonAddInoculum_click(event) {
    var row = this.datatableInoculums.appendChild( new Datatable.Row() );
    for (var i=0; i<this.datatableInoculums.firstElementChild.children.length; i++)
      row.appendChild( new Textbox() );
  }
  buttonRemoveInoculum_click(event) {
    if (this.datatableInoculums.children.length < 2) {
      error("no more rows to delete");
      return;
    }
    this.datatableInoculums.removeChild(this.datatableInoculums.lastElementChild);
  }
  buttonAddGrowthData_click(event) {
    var row = this.datatableGrowthData.appendChild( new Datatable.Row() );
    for (var i=0; i<this.datatableGrowthData.firstElementChild.children.length; i++)
      row.appendChild( new Textbox() );
  }
  buttonRemoveGrowthData_click(event) {
    if (this.datatableGrowthData.children.length < 2) {
      error("no more rows to delete");
      return;
    }
    this.datatableGrowthData.removeChild(this.datatableGrowthData.lastElementChild);
  }
  buttonAddAnalyticalData_click(event) {
    var row = this.datatableAnalyticalData.appendChild( new Datatable.Row() );
    for (var i=0; i<this.datatableAnalyticalData.firstElementChild.children.length; i++)
      row.appendChild( new Textbox() );
  }
  buttonRemoveAnalyticalData_click(event) {
    if (this.datatableAnalyticalData.children.length < 2) {
      error("no more rows to delete");
      return;
    }
    this.datatableAnalyticalData.removeChild(this.datatableAnalyticalData.lastElementChild);
  }
  buttonAddProduct_click(event) {
    for (var i=0; i<this.datatableAnalyticalData.children.length; i++)
      this.datatableAnalyticalData.children[i].appendChild( new Textbox() );
  }
  buttonRemoveProduct_click(event) {
    if (this.datatableAnalyticalData.firstElementChild.children.length < 2) {
      error("no more products to delete");
      return;
    }
    for (var i=0; i<this.datatableAnalyticalData.children.length; i++)
      this.datatableAnalyticalData.children[i].removeChild( this.datatableAnalyticalData.children[i].lastElementChild );
  }
  buttonClose_click(event) {
    this.close();
  }
  datetimepickerEndDate_change() {
    var duration = Math.round(moment.duration(moment(this.datetimepickerEndDate.value).diff(moment( new Date() ))).asHours());
    this.spinnerDuration.value = duration > 0 ? duration : 0;
  }
  spinnerDuration_change() {
    this.datetimepickerEndDate.value = moment.utc(new Date()).add(this.spinnerDuration.value, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  }
}

NewDialog.constructor();

export default NewDialog;